export default {
  path: '/users',
  name: 'users',
  component: () => import('../views/users/Users.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'users',
      linkText: 'Пользователи'
    }
  }
}